import { LoadingSpinner } from '@ecomm/checkout-icons'
import type { CheckoutFormValuesType } from '@ecomm/checkout/shipping-schema'
import { useCartLoaded } from '@ecomm/data-cart'
import { useTrackingShippingFormUserErrors } from '@ecomm/tracking'
import classNames from 'classnames'
import { useFormikContext } from 'formik'
import { useCallback } from 'react'

export function SubmitButton() {
  const { errors, submitCount } = useFormikContext<CheckoutFormValuesType>()
  const cartLoaded = useCartLoaded()
  const trackUserErrors = useTrackingShippingFormUserErrors()
  const hasErrors = Object.keys(errors).length > 0
  const showErrorMessage = hasErrors && submitCount > 0

  const onClick = useCallback(() => {
    hasErrors && trackUserErrors(errors)
  }, [errors, hasErrors, trackUserErrors])

  return (
    <div className="mt-5" data-component="CheckoutFormSubmission">
      <div className="flex flex-col-reverse md:flex-row md:items-center md:justify-end md:gap-5">
        <button
          aria-disabled={!cartLoaded}
          aria-labelledby={'checkout-submit-button-label'}
          className={classNames(
            'btn btn-solid-primary w-full min-w-[176px] px-6 py-3 md:h-[56px] md:w-auto',
            { 'cursor-not-allowed bg-btn-dark': !cartLoaded }
          )}
          data-component="checkout_submit_button"
          data-testid="checkout_submit_button"
          disabled={!cartLoaded}
          onClick={onClick}
          type="submit"
        >
          {cartLoaded ? (
            <span
              className="flex justify-center text-base text-white md:text-lg"
              id={'checkout-submit-button-label'}
            >
              Continue to payment
            </span>
          ) : (
            <LoadingSpinner />
          )}
        </button>
      </div>
      <div className="mt-5">
        {showErrorMessage ? (
          <p className="text:left text-sale text-base font-medium md:text-right">
            Please review your form for any missing fields.
          </p>
        ) : null}
      </div>
    </div>
  )
}
